// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase */
/* eslint camelcase: 0 */
// @ts-expect-error: Flow to TS migration.
import { stringify } from "query-string"
import jsonFetch from "@kiwicom/frontend-common/services/fetch/jsonFetch"
import sniffError from "@kiwicom/frontend-common/services/utils/sniffError"

import type { BookingId } from "../../../../../../types/primitiveTypes"
import apiBookingTokens from "../../../../../../../common/services/apiBookingTokens/apiBookingTokens"

// @ts-expect-error: Flow to TS migration.
export const apiUrl = () => window.reduxStore.getState().options.get("bookingApiUrl")

// Warning: Sending tokens in url is not good idea
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authFetch = (bid: any, url: any, options: any) => {
  const simpleToken = apiBookingTokens.getSimple(bid)
  const token = { simple_token: simpleToken }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const urlWithToken = `${url}?${stringify(token)}`

  return jsonFetch(urlWithToken, options).then((body) => {
    const maybeError = sniffError(null, { body })
    if (maybeError) throw new Error(maybeError)
    return body
  })
}

export function requestFastRefund(bid: BookingId) {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  return authFetch(bid, `${apiUrl()}/mmb/latest/bookings/${bid}/refund`, {
    body: {
      based_on: "grace_period",
      amount: 0, // 0 means all
      gate: "zooz",
      immediate: true,
    },
  })
}
